/**
 * Hero Section Adjustment Utility
 * Ensures the hero section fits properly within the viewport when scaling is applied
 */

class HeroAdjustment {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.adjustHero());
    } else {
      this.adjustHero();
    }

    // Listen for scale changes
    this.observeScaleChanges();
    
    // Listen for window resize
    window.addEventListener('resize', () => this.adjustHero());
  }

  adjustHero() {
    const heroSection = document.querySelector('#home');
    if (!heroSection) return;

    // Get current scale from CSS variable
    const computedStyle = getComputedStyle(document.documentElement);
    const currentScale = parseFloat(computedStyle.getPropertyValue('--auto-scale')) || 1;

    // Calculate adjusted viewport height
    const viewportHeight = window.innerHeight;
    const headerHeight = 64; // 4rem = 64px
    const availableHeight = viewportHeight - headerHeight;

    // Adjust hero section height based on scale
    const adjustedHeight = Math.max(availableHeight * 0.9, 500); // Minimum 500px

    // Apply the adjustment
    heroSection.style.minHeight = `${adjustedHeight}px`;

    // Ensure social links are visible
    this.ensureSocialLinksVisible();

    console.log(`🎯 Hero adjusted for scale ${Math.round(currentScale * 100)}%`);
    console.log(`   Viewport: ${viewportHeight}px, Adjusted: ${adjustedHeight}px`);
  }

  ensureSocialLinksVisible() {
    const socialSection = document.querySelector('#home .space-y-3');
    if (!socialSection) return;

    const rect = socialSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // If social links are below viewport, adjust hero height
    if (rect.bottom > viewportHeight) {
      const heroSection = document.querySelector('#home');
      if (heroSection) {
        const currentHeight = parseInt(heroSection.style.minHeight) || 500;
        const adjustment = rect.bottom - viewportHeight + 50; // 50px buffer
        heroSection.style.minHeight = `${Math.max(currentHeight - adjustment, 400)}px`;
        
        console.log(`📱 Social links adjusted: reduced height by ${adjustment}px`);
      }
    }
  }

  observeScaleChanges() {
    // Create a MutationObserver to watch for style changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const target = mutation.target;
          if (target === document.documentElement) {
            // Check if --auto-scale changed
            const style = target.getAttribute('style') || '';
            if (style.includes('--auto-scale')) {
              setTimeout(() => this.adjustHero(), 100);
            }
          }
        }
      });
    });

    // Start observing
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  // Manual adjustment method
  forceAdjust() {
    this.adjustHero();
  }
}

// Create and export singleton instance
const heroAdjustment = new HeroAdjustment();

// Make it available globally for debugging
if (typeof window !== 'undefined') {
  window.heroAdjustment = heroAdjustment;
}

export default heroAdjustment;